// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__-6f30","input":"Input_input__6mi9m","label":"Input_label__CjT52","error":"Input_error__iEjSg"};